import script from "./TranslationStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranslationStatus.vue?vue&type=script&setup=true&lang=ts"

import "./TranslationStatus.vue?vue&type=style&index=0&id=8793d5d8&lang=scss"

const __exports__ = script;

export default __exports__